import { useTranslation } from 'react-i18next'

import { Button, Modal, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const DeleteEmailTemplateModal = ({ show, onClose, onDelete }) => {
  const { t } = useTranslation()

  return (
    <Modal show={show} onClose={onClose} title={t('Eliminar plantilla')} size="m">
      <Styles.Container>
        <Text type="bodyMRegular">{t('¿Estás seguro de que quieres eliminar esta plantilla?')}</Text>
        <Styles.ActionsContainer>
          <Button fullWidth variant="outlined" onClick={onClose}>
            {t('Cancelar')}
          </Button>
          <Button fullWidth onClick={onDelete}>
            {t('Aceptar')}
          </Button>
        </Styles.ActionsContainer>
      </Styles.Container>
    </Modal>
  )
}

export default DeleteEmailTemplateModal
